export default __webpack_public_path__ + "static/B0278-a184529648a6c7466d9bc904ff273d6c.png";